import React from "react";
import { Skeleton, SkeletonVariant } from "../Skeleton";
import { AnalysisItem } from "../AnalysisItem";
import { List } from "../List";
import { InfoLabel } from "../InfoLabel";
import css from "./AnalysisSummary.module.scss";

export interface AnalysisSummaryProps {
  isLoading: boolean;
  items: string[];
}

const AnalysisSummary: React.FC<AnalysisSummaryProps> = ({ isLoading, items }) => {
  const attrs = {
    analysisItem: {
      isLoading,
      title: "Summary",
    },
    container: {
      className: css.container,
    },
    skeleton: {
      variant: SkeletonVariant.List,
    },
    list: {
      items,
    },
    infoLabel: {
      text: "No data to display yet",
      tooltip: "Summary cannot be determined yet",
    },
  };

  if (isLoading) {
    return (
      <AnalysisItem {...attrs.analysisItem}>
        <div {...attrs.container}>
          <Skeleton {...attrs.skeleton} />
          <Skeleton {...attrs.skeleton} />
        </div>
      </AnalysisItem>
    );
  }

  if (!items.length) {
    return (
      <AnalysisItem {...attrs.analysisItem}>
        <div {...attrs.container}>
          <InfoLabel {...attrs.infoLabel} />
        </div>
      </AnalysisItem>
    );
  }

  return (
    <AnalysisItem {...attrs.analysisItem}>
      <div {...attrs.container}>
        <List {...attrs.list} />
      </div>
    </AnalysisItem>
  );
};

export default AnalysisSummary;
